<template>
    <div class="d-flex overflow-visible">
        <validation-provider
            :name="name"
            :rules="rules"
            v-slot="{ errors, invalid, failed, changed, validated }"
        >
            <div class="d-flex flex-column dropdown">
                <div class="dropdown__title" v-html="title" />
                <div class="d-flex flex-column">
                    <div
                        ref="trigger"
                        class="dropdown__trigger d-flex flex-row justify-content-between align-items-center"
                        :class="{
                            'has-error': failed && (changed || validated),
                        }"
                        @click="toggle"
                    >
                        <input
                            :name="name"
                            type="select"
                            v-model="value"
                            v-show="false"
                            :id="id"
                        />
                        <span>{{ value }}</span>
                        <span class="ml-auto">
                            <i v-show="!isOpened" class="fas fa-caret-down"></i>
                            <i v-show="isOpened" class="fas fa-caret-up"></i>
                        </span>
                    </div>
                    <div
                        ref="dropdownMenu"
                        class="dropdown__menu"
                        v-show="isOpened"
                    >
                        <ul>
                            <li
                                v-for="val in values"
                                :key="val"
                                @click="select(val)"
                                :class="{ selected: val === value }"
                            >
                                {{ val }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <label
                class="dropdown__error_message"
                v-if="failed && (changed || validated)"
                >{{ errors[0] }}</label
            >
        </validation-provider>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => '',
        },
        value: { type: [String, Object, null], default: null },
        values: {
            type: Array,
            default: () => [],
        },
        rules: {
            type: String,
        },
        name: {
            type: String,
            default: () => 'ddd_name',
        },
        id: {
            type: String,
        },
    },
    data() {
        return {
            isOpened: false,
        };
    },
    methods: {
        select(value) {
            this.$emit('input', value);
            this.toggle();
        },
        toggle() {
            if (!this.isOpened) {
                this.$nextTick(() => (this.isOpened = true));
            } else {
                this.isOpened = false;
            }
        },
    },
};
</script>
